import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { login, loginError, loginSuccess } from "./auth.actions";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Injectable()
export class AuthEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private service = inject(AuthService);

    login$ = createEffect(() => this.actions$.pipe(
        ofType(login),
        exhaustMap(action => this.service.loginUser({ username: action.username, password: action.password })
            .pipe(
                map(response => {
                    const token = response.token;
                    const payload = this.service.getPayload(token);

                    const loginData = {
                        user: { username: payload!.sub , companyName: payload!.companyName, fullName: payload!.full_name, companyId: payload!.companyId},
                        isAuth: true,
                        isAdmin: payload!.isAdmin,
                        isSuperAdmin: payload!.isSuperAdmin,
                        groups: payload!.groups,
                        groupsDescription: payload!.groupsDescription
                    };

                    this.service.token = token;
                    this.service.user = loginData
                    return loginSuccess({ login: loginData });
                }),
                catchError((error) => of(loginError({error: error.error.message})))
        ))
    ));

    loginSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(loginSuccess),
        tap((action) => {
            if(this.service.isRol('ROL_AUT')){
                this.router.navigate(['/requestedSignatures']);
            }else if(action.login.isAdmin){
                this.router.navigate(['/offers']);
            }else if(action.login.isSuperAdmin){
                this.router.navigate(['/companies']);
            }else{
                this.router.navigate(['/offers']);
            }
        })
    ), {dispatch: false});

    loginError$ = createEffect(() => this.actions$.pipe(
        ofType(loginError),
        tap((action) => {
            Swal.fire('Error en el Login', action.error, 'error')
        })
    ), { dispatch: false });

}